<template>
  <svg class="text-white" xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24">
    <g >
      <rect width="26" height="4" rx="2" fill="#498e16"/>
      <rect width="26" height="4" rx="2" transform="translate(0 10)" fill="#498e16"/>
      <rect width="26" height="4" rx="2" transform="translate(0 20)" fill="#498e16"/>
    </g>
  </svg>
</template>
